import React from 'react';

import { SVGComponentProps } from './svg.types';

const EnterPromptSVG = ({
  fill = 'currentColor',
  size = '1em',
  ...otherProps
}: Omit<SVGComponentProps, 'wrapperClass'>) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 5C3 4.44772 3.44772 4 4 4H11C11.5523 4 12 4.44772 12 5C12 5.55228 11.5523 6 11 6H8.5V18H11C11.5523 18 12 18.4477 12 19C12 19.5523 11.5523 20 11 20H4C3.44772 20 3 19.5523 3 19C3 18.4477 3.44772 18 4 18H6.5V6H4C3.44772 6 3 5.55228 3 5Z"
        fill={fill}
      />
      <path
        d="M15.3474 8.51328C15.5133 7.82891 16.4867 7.82891 16.6526 8.51328L17.1092 10.3964C17.1685 10.6407 17.3593 10.8315 17.6036 10.8908L19.4867 11.3474C20.1711 11.5133 20.1711 12.4867 19.4867 12.6526L17.6036 13.1092C17.3593 13.1685 17.1685 13.3593 17.1092 13.6036L16.6526 15.4867C16.4867 16.1711 15.5133 16.1711 15.3474 15.4867L14.8908 13.6036C14.8315 13.3593 14.6407 13.1685 14.3964 13.1092L12.5133 12.6526C11.8289 12.4867 11.8289 11.5133 12.5133 11.3474L14.3964 10.8908C14.6407 10.8315 14.8315 10.6407 14.8908 10.3964L15.3474 8.51328Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 9.24146L15.6739 10.5863C15.5436 11.1238 15.1238 11.5436 14.5863 11.6739L13.2415 12L14.5863 12.3261C15.1238 12.4564 15.5436 12.8762 15.6739 13.4137L16 14.7585L16.3261 13.4137C16.4564 12.8762 16.8762 12.4564 17.4137 12.3261L18.7585 12L17.4137 11.6739C16.8762 11.5436 16.4564 11.1238 16.3261 10.5863L16 9.24146ZM16.6526 8.51328C16.4867 7.82891 15.5133 7.82891 15.3474 8.51328L14.8908 10.3964C14.8315 10.6407 14.6407 10.8315 14.3964 10.8908L12.5133 11.3474C11.8289 11.5133 11.8289 12.4867 12.5133 12.6526L14.3964 13.1092C14.6407 13.1685 14.8315 13.3593 14.8908 13.6036L15.3474 15.4867C15.5133 16.1711 16.4867 16.1711 16.6526 15.4867L17.1092 13.6036C17.1685 13.3593 17.3593 13.1685 17.6036 13.1092L19.4867 12.6526C20.1711 12.4867 20.1711 11.5133 19.4867 11.3474L17.6036 10.8908C17.3593 10.8315 17.1685 10.6407 17.1092 10.3964L16.6526 8.51328Z"
        fill={fill}
      />
      <path
        d="M21 5C21 5.55228 20.5523 6 20 6C19.4477 6 19 5.55228 19 5C19 4.44772 19.4477 4 20 4C20.5523 4 21 4.44772 21 5Z"
        fill={fill}
      />
      <path
        d="M21 19C21 19.5523 20.5523 20 20 20C19.4477 20 19 19.5523 19 19C19 18.4477 19.4477 18 20 18C20.5523 18 21 18.4477 21 19Z"
        fill={fill}
      />
    </svg>
  );
};

export default EnterPromptSVG;
